<template>
  <div class="brand-product-component">
    <div class="brand-section app-basic-layout-wrapper">
      <h3 class="title font-30">品牌号方案</h3>
      <p class="subtitle font-color-desc">互动营销新途径，激活潜在兴趣人群</p>
      <div class="body">
        <ul class="tabs">
          <li
            v-for="(item, index) in tabs"
            :key="item.id"
            :class="{ active: activeIndex === index }"
            @click="changeTab(index)"
          >
            <div class="tab-item">{{ item.title }}</div>
          </li>
        </ul>
        <template v-for="(item, index) in tabs">
          <div v-if="activeIndex === index" :key="item.id" class="tab-content">
            <div class="main-content">
              <h3 class="content-title">{{ item.title }}</h3>
              <p class="desc">{{ item.desc }}</p>
              <div class="button" @click="$emit('register')">
                免费咨询，开始使用
              </div>
            </div>
            <div class="image-wrapper">
              <img :src="item.img" />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import fangan1 from '@/assets/img/brand/fensijingying.png'
import fangan2 from '@/assets/img/brand/pinpaijingying.png'
import fangan3 from '@/assets/img/brand/neirongjingying.png'
import fangan4 from '@/assets/img/brand/pinpaizhiyou.png'

export default {
  data() {
    return {
      activeIndex: 0,
      tabs: [
        {
          id: 1,
          title: '粉丝经营',
          desc: '以"任务+奖励"的形式激励用户互动参与，粉丝高效互动，扩大粉丝流量，实现私域流量向公域转化',
          img: fangan1
        },
        {
          id: 2,
          title: '品牌经营',
          desc: '品牌号全新profile页，稳定入口展现品牌内容及产品，实现品牌资产沉淀和积累',
          img: fangan2
        },
        {
          id: 3,
          title: '内容经营',
          desc: '稳定的社交资产沉淀，内容可控，优质内容聚合，软性原生塑造影响力，实现公域流量向私域转化',
          img: fangan3
        },
        {
          id: 4,
          title: '品牌挚友',
          desc: '品牌与KOL之间强关联，投放挚友内容，释放品牌x明星信息收割粉丝，挚友公域流量向品牌私域流量转化',
          img: fangan4
        }
      ]
    }
  },
  methods: {
    changeTab(index) {
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.body {
  padding-top: 60px;
  position: relative;
  padding-left: 271px;
  .tabs {
    position: absolute;
    left: 0;
    top: 60px;
    height: 177px;
    border-left: 3px solid rgba(142, 144, 145, 0.25);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .tab-item {
      padding-left: 19px;
      cursor: pointer;
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      position: relative;
    }
    li {
      &.active {
        color: $text-color-copper;
        .tab-item {
          &:after {
            content: '';
            background-color: $text-color-copper;
            position: absolute;
            width: 3px;
            height: 100%;
            left: -3px;
            top: 0;
          }
        }
      }
    }
  }
  .tab-content {
    padding-right: 458px;
    position: relative;
    min-height: 525px;
    .image-wrapper {
      position: absolute;
      right: 0;
      top: 0;
      width: 436px;
      height: 613px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        float: left;
        object-fit: cover;
      }
    }
    .content-title {
      font-size: 26px;
      line-height: 32px;
      margin-bottom: 52px;
    }
    .desc {
      font-size: 18px;
      margin-bottom: 104px;
      line-height: 36px;
    }
    .button {
      width: 208px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      text-align: center;
      color: #ffffff;
      border-radius: 24px;
      background-color: $base-color-1;
      display: inline-block;
      cursor: pointer;
    }
  }
}
</style>
